let ClinicalPractice = function (tokenClient, serviceAddr) {
  let TokenClient = tokenClient;
  let ServiceBaseAddress = serviceAddr;

  /**
   * 获取临床技术操作规范首页
   * @param {any} success
   * @param {any} error
   */
  this.Clinical = function (success, error) {
      var url = ServiceBaseAddress + '/api/ClinicalPractice/Index';
      TokenClient.Get(url, true, null, null,
          function (data) {
              if (success) {
                  var jsonObj = JSON.parse(data);
                  success(jsonObj);
              }
          }, error);
  }

  /**
   * 获取临床技术操作规范详情
   * @param {any} success
   * @param {any} error
   */
  this.Detail = function (params,success, error) {
      var url = ServiceBaseAddress + '/api/ClinicalPractice/' + params;
      TokenClient.Get(url, true, null, null,
          function (data) {
              if (success) {
                  var jsonObj = JSON.parse(data);
                  success(jsonObj);
              }
          }, error);
  }
}

export { ClinicalPractice }